module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/baby-sitting/child-age4-8a1bd7341afb23562a844c137c444fd3.svg";